import { render, staticRenderFns } from "./RegistroCasamento.vue?vue&type=template&id=df859fdc&scoped=true&"
import script from "./RegistroCasamento.vue?vue&type=script&lang=js&"
export * from "./RegistroCasamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df859fdc",
  null
  
)

export default component.exports